var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71289 18.958L7.26562 18.9102C5.41069 18.7146 3.69325 17.8404 2.44434 16.4551C1.19556 15.0697 0.502824 13.2713 0.5 11.4062C0.5 11.3174 0.534841 11.2318 0.597656 11.1689C0.660472 11.1061 0.746126 11.0713 0.834961 11.0713C0.923792 11.0713 1.00945 11.1061 1.07227 11.1689C1.13508 11.2318 1.16992 11.3174 1.16992 11.4062C1.16992 13.2304 1.89473 14.9797 3.18457 16.2695C4.47441 17.5593 6.22377 18.2842 8.04785 18.2842C9.87192 18.2841 11.6213 17.5593 12.9111 16.2695C14.2009 14.9797 14.9258 13.2303 14.9258 11.4062C14.9258 11.3174 14.9606 11.2318 15.0234 11.1689C15.0862 11.1062 15.172 11.0713 15.2607 11.0713C15.3493 11.0713 15.4343 11.1064 15.4971 11.1689C15.5442 11.2161 15.576 11.2764 15.5889 11.3408L15.5957 11.4062C15.5931 13.2714 14.9002 15.0697 13.6514 16.4551C12.4024 17.8405 10.6851 18.7148 8.83008 18.9102L8.38281 18.958V23.165C8.38281 23.2539 8.347 23.3395 8.28418 23.4023C8.22143 23.4649 8.13646 23.5 8.04785 23.5C7.95903 23.5 7.87336 23.4651 7.81055 23.4023C7.74773 23.3395 7.71289 23.2539 7.71289 23.165V18.958Z",
    fill: "url(#paint0_linear_60_15141)",
    stroke: "url(#paint1_linear_60_15141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04395 0.5C9.45804 0.500128 10.8145 1.0616 11.8145 2.06152C12.8144 3.06145 13.3758 4.41793 13.376 5.83203V11.4053C13.3743 12.8186 12.8119 14.1735 11.8125 15.1729C10.8131 16.1722 9.45826 16.7347 8.04492 16.7363L7.78125 16.7295C6.4634 16.6635 5.21309 16.111 4.27539 15.1738C3.33772 14.2367 2.7845 12.9867 2.71777 11.6689L2.71094 11.4043V5.83203C2.71106 4.41794 3.27253 3.06145 4.27246 2.06152C5.2725 1.06148 6.62967 0.5 8.04395 0.5Z",
    fill: "url(#paint2_linear_60_15141)",
    stroke: "url(#paint3_linear_60_15141)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_15141",
    x1: 2.13182,
    y1: 10.9324,
    x2: 14.602,
    y2: 39.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_15141",
    x1: 1.92868,
    y1: 10.5713,
    x2: 15.1909,
    y2: 24.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60_15141",
    x1: 3.75595,
    y1: 0.463497,
    x2: 24.8656,
    y2: 27.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60_15141",
    x1: 3.60873,
    y1: -3.28516e-7,
    x2: 18.7565,
    y2: 9.20284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic_on.179564b38bbdf3008bc2b358167889dc.svg";
export { ForwardRef as ReactComponent };